// @ts-nocheck
const intakeScreens = {
  contractorInvite: "contractor-invite"
};

export {
  intakeScreens
};